// extracted by mini-css-extract-plugin
export default {"showdow":"PaySupplier_showdow__-k1Gv"};